// Per-session marker that the patient's browser location has already been
// resolved (successfully or not) for this login session. Lets the dashboard
// re-detect the browser location once per session — so a returning or
// redirected patient reflects where they are now instead of being pinned to a
// previously cached selection — while still skipping repeat lookups on every
// in-session refresh or navigation.

const SESSION_SYNC_KEY_PREFIX = 'patientLocationSynced:';

const sessionKey = (userId: number): string => `${SESSION_SYNC_KEY_PREFIX}${userId}`;

export const hasSyncedPatientLocationThisSession = (userId: number): boolean => {
  try {
    return sessionStorage.getItem(sessionKey(userId)) === '1';
  } catch {
    return false;
  }
};

export const markPatientLocationSynced = (userId: number): void => {
  try {
    sessionStorage.setItem(sessionKey(userId), '1');
  } catch {
    /* sessionStorage unavailable; nothing to persist */
  }
};
